import React, { Component } from "react";
import DateSetUpPanelView from "presentational/upload/DateSetUpPanelView";
import PropTypes from "prop-types";

class DateSetUpPanel extends Component {
  static propTypes = {
    stickeredImageDataURL: PropTypes.string.isRequired,
    calendarDate: PropTypes.string.isRequired,
    calendarAgreement: PropTypes.bool.isRequired,
    onCalendarDateChange: PropTypes.func.isRequired,
    onCalendarAgreementChange: PropTypes.func.isRequired,
    onBackClick: PropTypes.func.isRequired,
    onNextClick: PropTypes.func.isRequired
  };

  handleBackBtnClick = () => {
    const { onBackClick } = this.props;
    onBackClick();
  };

  handleNextBtnClick = () => {
    const { onNextClick } = this.props;
    onNextClick();
  };

  render() {
    const {
      stickeredImageDataURL,
      calendarDate,
      calendarAgreement,
      onCalendarDateChange,
      onCalendarAgreementChange
    } = this.props;

    return (
      <DateSetUpPanelView
        stickeredImageDataURL={stickeredImageDataURL}
        calendarDate={calendarDate}
        calendarAgreement={calendarAgreement}
        onCalendarDateChange={onCalendarDateChange}
        onCalendarAgreementChange={onCalendarAgreementChange}
        onBackBtnClick={this.handleBackBtnClick}
        onNextBtnClick={this.handleNextBtnClick}
      />
    );
  }
}

export default DateSetUpPanel;
